import React, { FunctionComponent } from "react";

const TimeReverseIcon: FunctionComponent = () => {
  // https://www.streamlinehq.com/icons/streamline-regular/interface-essential/time/time-reverse
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="-0.25 -0.25 24.5 24.5">
      <defs></defs>
      <title>time-reverse</title>
      <polyline
        points="9.163 17.603 12.162 14.603 12.163 9.603"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      ></polyline>
      <polyline
        points="14.158 6.853 10.158 3.603 14.658 0.853"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      ></polyline>
      <path
        d="M3.707,18.6A9.837,9.837,0,1,0,10.221,3.635"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      ></path>
      <path
        d="M6.852,4.937A9.97,9.97,0,0,0,3.809,7.873"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      ></path>
      <path
        d="M2.336,11.5a10.211,10.211,0,0,0,.13,4.227"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      ></path>
    </svg>
  );
};

export default TimeReverseIcon;
